// Paint text with the metric-adjusted local fallback, then let HtmlDocument
// activate the same Inter file after first contentful paint. CSS variables
// keep article titles on their heavier fallback until Inter is available.
const deferInter = {
  variable: 'ht-defer-font',
  className: 'ht-defer-font',
  style: { fontFamily: 'var(--inter-title-font)' },
}

export const inter = deferInter
export const interFallback = deferInter
